var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "store",
    d: "m20 13.08v4.92a2.652 2.652 0 0 1 -3 3h-2.67a.3.3 0 0 1 -.3-.3v-3.078a2.087 2.087 0 0 0 -1.658-2.093 2.005 2.005 0 0 0 -2.342 1.971v3.2a.3.3 0 0 1 -.3.3h-2.73a2.652 2.652 0 0 1 -3-3v-4.92a4.429 4.429 0 0 0 1.9.42 5.006 5.006 0 0 0 3.07-1.06 4.875 4.875 0 0 0 6.07 0 5.006 5.006 0 0 0 3.07 1.06 4.417 4.417 0 0 0 1.89-.42zm-12.5-10.08c-2.5 0-2.883.82-3.295 2.038l-1.04 3.073a2.924 2.924 0 0 0 1.2 3.481 3.058 3.058 0 0 0 1.535.408 3.281 3.281 0 0 0 3.055-2 3.318 3.318 0 0 0 6.09 0 3.281 3.281 0 0 0 3.055 2 3.058 3.058 0 0 0 1.536-.408 2.924 2.924 0 0 0 1.2-3.481l-1.036-3.073c-.417-1.218-.8-2.038-3.3-2.038z",
    fill: "rgb(0,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.01b0968b56cc00c843e3e187c56e5e70.svg";
export { ForwardRef as ReactComponent };